import { makeVar, useReactiveVar } from '@apollo/client';

export type AccessoriesBarState = {
    currentSku?: string;
};

const accessoriesBarState = makeVar<AccessoriesBarState>({ currentSku: undefined });

export const useAccessoriesBarState = () => useReactiveVar(accessoriesBarState);

export const setBoughtProductForAccessories = (sku: string): void => {
    const state = accessoriesBarState();

    if (state.currentSku === sku) {
        return;
    }

    accessoriesBarState({
        currentSku: sku
    });
};

export const resetAccessoriesBar = (): void => {
    accessoriesBarState({ currentSku: undefined });
};
